import { gql } from '@apollo/client';

export const fetchOperationsList = gql`
  query operators(
    $filter: FilterOperators
    $pagingOptions: PagingOptionsInput!
  ) {
    operators(filter: $filter, pagingOptions: $pagingOptions) {
      data {
        id
        name
        role
        email
        phoneNumber
        language
        isPhoneNotified
        isEmailNotified
        isResourceStatus
        isBatteryDeepDischarge
        isCleaningTaskStopped
        isCleaningTaskFinished
        isEmergencyStop
        isErrorOccurred
        isServiceNeeded
        isLocationStatus
        machine {
          alias
          thumbnail
          materialNumber
        }
      }
      metadata {
        totalCount
      }
    }
  }
`;
